<div class="consent-dashboard-page container-fluid">

  <div class="row">
    <div class="col-12">
      <div class="mat-h3">Consent Dashboard</div>
      <div class="mat-body-2 subtitle">Privacy consent engagement and timeframe analysis at the individual level. Figures cover individuals whose first consent form was created within the selected range.</div>
    </div>
  </div>

  <mat-card appearance="outlined" class="controls-card">
    <div class="controls">
      <div class="control">
        <label class="control-label">From</label>
        <input type="date" class="date-input" [formControl]="formControlFrom" [max]="to">
      </div>
      <div class="control">
        <label class="control-label">To</label>
        <input type="date" class="date-input" [formControl]="formControlTo" [min]="from">
      </div>
      <div class="control">
        <label class="control-label">Group by</label>
        <select class="granularity-select" [formControl]="formControlGranularity">
          @for (g of granularities; track g) {
            <option [value]="g">{{ g | titlecase }}</option>
          }
        </select>
      </div>
      <div class="control-actions">
        <button mat-flat-button color="primary" (click)="applyRange()">
          <mat-icon>refresh</mat-icon>
          Apply
        </button>
        <button mat-stroked-button (click)="downloadCsv()" matTooltip="Download the underlying data for the selected range as CSV">
          <mat-icon>download</mat-icon>
          Download CSV
        </button>
      </div>
    </div>
  </mat-card>

  @if (metrics) {
    <div class="metrics-grid">
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.totalIndividuals | number }}</div>
        <div class="metric-label">Individuals</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.signedIndividuals | number }}</div>
        <div class="metric-label">Signed</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card highlight">
        <div class="metric-value">{{ metrics.completionRatePercent | number:'1.0-1' }}%</div>
        <div class="metric-label">Completion rate</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ formatHours(metrics.avgHoursToSign) }}</div>
        <div class="metric-label">Avg time to sign</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ formatHours(metrics.medianHoursToSign) }}</div>
        <div class="metric-label">Median time to sign</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.pendingIndividuals | number }}</div>
        <div class="metric-label">Pending</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.declinedIndividuals | number }}</div>
        <div class="metric-label">Declined</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.expiredIndividuals | number }}</div>
        <div class="metric-label">Expired</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.totalEnvelopes | number }}</div>
        <div class="metric-label">Envelopes sent</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card">
        <div class="metric-value">{{ metrics.avgFormsPerIndividual | number:'1.0-1' }}</div>
        <div class="metric-label">Avg forms / individual</div>
      </mat-card>
      <mat-card appearance="outlined" class="metric-card" matTooltip="Average time from a single envelope being created to its outcome (signed / declined / expired / superseded / invalidated)">
        <div class="metric-value">{{ formatHours(metrics.avgHoursToActionEnvelope) }}</div>
        <div class="metric-label">Avg time to action envelope</div>
      </mat-card>
    </div>
  }

  @if (!hasData) {
    <mat-card appearance="outlined" class="empty-state">
      <mat-icon>insights</mat-icon>
      <div>No consent forms were created in the selected range.</div>
    </mat-card>
  }

  <div class="charts-grid" [class.hidden]="!hasData">
    <mat-card appearance="outlined" class="chart-card wide">
      <div class="chart-title">Individuals over time (entered vs signed)</div>
      <div class="chart-canvas-wrapper">
        <canvas #volumeChart></canvas>
      </div>
    </mat-card>

    <mat-card appearance="outlined" class="chart-card">
      <div class="chart-title">Average time to sign — individual journey (point-in-time trend)</div>
      <div class="chart-canvas-wrapper">
        <canvas #durationChart></canvas>
      </div>
    </mat-card>

    <mat-card appearance="outlined" class="chart-card">
      <div class="chart-title">Outcome breakdown (per individual)</div>
      <div class="chart-canvas-wrapper">
        <canvas #statusChart></canvas>
      </div>
    </mat-card>
  </div>

</div>
